<template>
  <div>
    <img :src="item.icon" alt="">
    <p class="md-subheading catalog__item-title" v-html="item.name"></p>
    <div>
      <span class="md-body-1" v-if="item.quantity">{{item.quantity}}<br></span>
      <span class="md-body-2">CHF {{item.price.toFixed(2)}}</span><br>
      <span v-if="item.mwst" class="md-body-1">{{mwstValue(item.mwst)}}</span>
    </div>
  </div>
</template>

<script>
    export default {
        name: "CatalogItem",
        props: ['item'],
        methods: {
            mwstValue: function(mwst) {
                let tmp = mwst * 100
                return 'MwSt. ' + tmp.toFixed(2) + '%'
            }
        }
    }
</script>